<template lang="pug">
  .videoPopup
    .videoPopup__content
      .videoPopup__closer(@click="$emit('close')")
      .videoPopup__video
        iframe(:id="id" ref="iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
        .videoPopup__poster(:style="{backgroundImage: 'url('+poster+')'}")
        .videoPopup__play-btn(v-if="!isPlay" @click="play()")
</template>

<script>
export default {
  name: "VideoPopup",

  props: {
    src: {
      default: '',
    }
  },

  data: () => ({
    isReady: false,
    id: null,
    isPlay: false,
    player: null,
    poster: null,
  }),

  methods: {
    play() {
      if (!this.isReady){
        this.$refs.iframe.src = `https://www.youtube.com/embed/${this.youtube_parser(this.src)}?enablejsapi=1&rel=0`;
        this.player = new YT.Player(this.id, {
          videoId: 'M7lc1UVf-VE',
          events: {
            onReady: ()=>{
              this.player.playVideo()
              this.isPlay = true;
              this.isReady = true;
              this.$refs.iframe.classList.add('hidePoster');
            },
            onStateChange: this.onStateChange,
          }
        });
      }else {
        this.player.playVideo()
        this.isPlay = true;
        this.$refs.iframe.classList.add('hidePoster');
      }
    },
    onStateChange(event) {
      if (event.data === 1) {
        this.isPlay = true;
      } else if (event.data === 2) {
        this.isPlay = false;
      }
    },
    youtube_parser(url) {
      var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[1].length == 11) ? match[1] : false;
    }
  },

  beforeMount() {
    this.$store.commit('pageHidden');
    this.poster = `https://img.youtube.com/vi/${this.youtube_parser(this.src)}/0.jpg`;
    this.id = 'p' + this._uid;
  },
  beforeDestroy() {
    this.$store.commit('pageDelHidden');
  }
}
</script>

<style scoped lang="scss">
.videoPopup {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(#000, 0.5);

  &__content {
    position: relative;
    width: 113.5vh;
    height: 84.5vh;
    padding: 5.6rem 0 5.6rem;
    border: 0.25rem solid #fff;
    border-radius: 2rem;
    box-shadow: 0 0 0.5rem #fff;
    backdrop-filter: blur(0.5rem);
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      background-color: rgba(#000, 0.6);
    }
    @media screen and (min-width: 0 \0) and (min-resolution: .001dpcm) {
      background-color: rgba(#000, 0.6);
    }
  }

  &__video {
    position: relative;
    width: 100%;
    height: 100%;
  }
  &__poster {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: no-repeat center center / cover;
  }
  &__play-btn {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10rem;
    height: 10rem;
    border-radius: 50%;
    cursor: pointer;
    background: url(../assets/img/play-button.png)  no-repeat center center / contain;
    transition: transform .3s;
    &:hover {
      transform: translate(-50%, -50%) scale(1.05);
    }
  }

  iframe {
    width: 100%;
    height: 100%;
    &.hidePoster + .videoPopup__poster {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__closer {
    position: absolute;
    top: 1.75rem;
    right: 1.65rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 0.25rem;
      border-radius: 1rem;
      background: #fff;
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
  @include mobile_or_P {

    &__content {
      display: flex;
      align-items: center;
      max-width: 100vmin;
      height: auto;
      padding: 14vmin 0 12vmin;

      border-right: none;
      border-left: none;
      border-radius: 0px;
    }

    &__closer {
      top: 1.3rem;
      right: 1.1rem;

      width: 7vmin;
      height: 7vmin;
      &:before, &:after {
        height: 0.75vmin;
      }

    }

    &__video {
      height: 57vmin;
    }

    &__play-btn {
      width: 15vmin;
      height: 15vmin;
    }
  }
  @media screen and (max-width: 900px) and (orientation: landscape) {
    &__content {
      height: 100%;
      border-right: 0.25rem solid #fff;
      border-left: 0.25rem solid #fff;
      border-top: 0px;
      border-bottom: 0px;
    }

  }
  }
</style>